const ApiResolvers = require('@/lib/Api/ApiResolvers');
const ApiResponseUnmapper = require('../libraries/DigiTickets/Api/ApiResponseUnmapper');

/**
 * @param $resource
 * @param {ApiRequestParams} apiRequestParams
 * @param {AppConfig} appConfig
 * @param {UserService} userService
 * @return {*}
 * @constructor
 */
const ProductResource = function (
    $resource,
    apiRequestParams,
    appConfig,
    userService
) {
    return $resource(
        appConfig.apiBaseUrl + 'products/',
        Object.assign(
            apiRequestParams.defaults(),
            {
                branchID: () => userService.getItemBranchID(),
                channelID: appConfig.channelID,
            }
        ),
        {
            query: {
                isArray: true,
                params: Object.assign(
                    {
                        resolve: [
                            'categories',
                            ApiResolvers.ITEM_BARCODES,
                        ].join(','),
                        excludeFields: apiRequestParams.defaultExcludeFields(),
                    },
                    apiRequestParams.defaultMappers()
                ),
                transformResponse: (json) => ApiResponseUnmapper.transformApiResponse(json, 'Product'),
            },
        }
    );
};

module.exports = ProductResource;
